/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type UiEmptyStateProps = {
    icon?: React.ReactNode
    title: React.ReactNode
    description?: React.ReactNode
    action?: React.ReactNode
    className?: string
}

const UiEmptyState: React.FC<UiEmptyStateProps> = ({
    icon,
    title,
    description,
    action,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiEmptyState w-full h-full flex items-center justify-center px-6 py-6',
                className
            )}
        >
            <div className={clsx('text-center max-w-xl mx-auto')}>
                {icon && (
                    <div
                        className={clsx(
                            'mx-auto mb-4 flex items-center justify-center'
                        )}
                    >
                        {icon}
                    </div>
                )}
                <div
                    className={clsx(
                        'text-lg font-semibold text-gray-900',
                        'dark:text-gray-100'
                    )}
                >
                    {title}
                </div>
                {description && (
                    <div
                        className={clsx(
                            'mt-2 text-sm text-gray-600',
                            'dark:text-gray-400'
                        )}
                    >
                        {description}
                    </div>
                )}
                {action && <div className={clsx('mt-6')}>{action}</div>}
            </div>
        </div>
    )
}

export default UiEmptyState
